<template>
  <div class="oneLabel">
      <img src="../../assets/images/homePage/HPOne.png"/>
    {{postName}}
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    postName: String
  },
  data () {
    return {
      msg:''
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "oneLabel.less";
</style>



// WEBPACK FOOTER //
// src/cmscomponents/oneLabel/oneLabel.vue